import { render } from "./Children.vue?vue&type=template&id=d8a7543a"
import script from "./Children.vue?vue&type=script&lang=js"
export * from "./Children.vue?vue&type=script&lang=js"

import "./Children.vue?vue&type=style&index=0&id=d8a7543a&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__